import Controller from '@ember/controller';
import { SERVICE_NAMES } from 'walden-fast/utils/constants/services';
import { service } from '@ember/service';
import type { IntlService } from 'ember-intl';
import type { ShowcaseContentTab } from 'walden-fast/components/showcase-content';
import type { AppServicesWaldenPulseModel } from 'walden-fast/routes/app/services/walden-pulse';

export default class AppServicesWaldenPulseController extends Controller {
  declare model: AppServicesWaldenPulseModel;

  @service('intl') declare intlService: IntlService;

  serviceName = SERVICE_NAMES.WALDEN_PULSE;

  get tabs(): ShowcaseContentTab[] {
    return [
      {
        label: this.intlService.t('pages.waldenPulse.teaser.tabFeedback.label'),
        value: 'yourNeeds',
        iconName: 'hand-heart',
        title: this.intlService.t('pages.waldenPulse.teaser.tabFeedback.label'),
        description: this.intlService.t(
          'pages.waldenPulse.teaser.tabFeedback.description',
        ),
        image: '/assets/images/pulse_teaser_1.png',
        primaryCta: {
          type: 'activate-service',
          label: this.intlService.t(
            'pages.waldenPulse.teaser.primaryCta.label',
          ),
          value: '',
        },
      },
      {
        label: this.intlService.t('pages.waldenPulse.teaser.tabSmarter.label'),
        value: 'unlock',
        iconName: 'circle-gauge',
        title: this.intlService.t('pages.waldenPulse.teaser.tabSmarter.label'),
        description: this.intlService.t(
          'pages.waldenPulse.teaser.tabSmarter.description',
        ),
        image: '/assets/images/pulse_teaser_2.png',
        primaryCta: {
          type: 'activate-service',
          label: this.intlService.t(
            'pages.waldenPulse.teaser.primaryCta.label',
          ),
          value: '',
        },
      },
      {
        label: this.intlService.t(
          'pages.waldenPulse.teaser.tabRelationships.label',
        ),
        value: 'feedback',
        iconName: 'messages-square',
        title: this.intlService.t(
          'pages.waldenPulse.teaser.tabRelationships.label',
        ),
        description: this.intlService.t(
          'pages.waldenPulse.teaser.tabRelationships.description',
        ),
        image: '/assets/images/pulse_teaser_3.png',
        primaryCta: {
          type: 'activate-service',
          label: this.intlService.t(
            'pages.waldenPulse.teaser.primaryCta.label',
          ),
          value: '',
        },
      },
    ];
  }
}
